// Module
var code = "<mammo-quality-control-artifact-evaluation-grid></mammo-quality-control-artifact-evaluation-grid>\n\n<tabs-navigation identifier=\"app.mammoQualityControl.artifactEvaluation\"\n                 state=\"app.mammoQualityControl.artifactEvaluation.listing\">\n</tabs-navigation>";
// Exports
module.exports = code;